export default "__VITE_ASSET__FhqOVjOR__"